import React from 'react';
import { useNavigate } from 'react-router-dom';

const STORAGE_KEY = 'profile_notice_dismissed_v1';

export const isProfileNoticeDismissed = () =>
  localStorage.getItem(STORAGE_KEY) === 'true';

const ProfileNoticeModal = ({ onClose }) => {
  const navigate = useNavigate();

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    onClose();
  };

  const handleGoToProfile = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    onClose();
    navigate('/profile');
  };

  return (
    <div className="modal-overlay profile-notice-overlay">
      <div className="modal-container profile-notice-modal">
        <div className="modal-header">
          <h3>Complétez votre profil</h3>
          <button className="modal-close" onClick={onClose}>
            <i className="material-icons">close</i>
          </button>
        </div>

        <div className="modal-body profile-notice-body">
          <p className="profile-notice-intro">
            Votre profil vous permet de renseigner des informations utiles pour le suivi de vos soumissions et commandes.
          </p>

          <div className="profile-notice-items">
            <div className="profile-notice-item">
              <div className="profile-notice-item__icon">
                <i className="material-icons">business</i>
              </div>
              <div className="profile-notice-item__content">
                <strong>Informations entreprise</strong>
                <p>Renseignez le nom, le SIRET, l'adresse et le téléphone de votre entreprise. Ces informations sont utilisées pour identifier vos fichiers lors des téléchargements.</p>
              </div>
            </div>

            <div className="profile-notice-item">
              <div className="profile-notice-item__icon">
                <i className="material-icons">beach_access</i>
              </div>
              <div className="profile-notice-item__content">
                <strong>Congés &amp; absences</strong>
                <p>Déclarez vos périodes d'absence à l'avance pour informer l'équipe et éviter tout malentendu sur vos délais de réponse.</p>
              </div>
            </div>

            <div className="profile-notice-item">
              <div className="profile-notice-item__icon">
                <i className="material-icons">upload_file</i>
              </div>
              <div className="profile-notice-item__content">
                <strong>Nouveaux formats acceptés</strong>
                <p>En plus des fichiers STL et PDF, vous pouvez désormais joindre des fichiers <strong>PLY</strong>, <strong>DICOM (.dcm)</strong> et <strong>CAM</strong> lors de vos soumissions.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer profile-notice-footer">
          <button className="btn btn-link btn-sm profile-notice-dismiss" onClick={handleDismiss}>
            Ne plus me le rappeler
          </button>
          <div className="profile-notice-footer__right">
            <button className="btn btn-outline-secondary" onClick={onClose}>
              Fermer
            </button>
            <button className="btn btn-primary" onClick={handleGoToProfile}>
              <i className="material-icons">person</i>
              Accéder au profil
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileNoticeModal;
